export const GROUPS__ADMINISTRATORS = 1;
export const GROUPS__COACHES = 2;
export const GROUPS__CLIENTS = 3;
